export function phoneMask(phone: string) {
  return phone
    .replace(/\D/g, '')
    .replace(/^(\d)/, '($1')
    .replace(/^(\(\d{2})(\d)/, '$1) $2')
    .replace(/(\d{5})(\d{1,4})/, '$1-$2')
    .replace(/(-\d{4})\d+$/, '$1')
}

// Número de WhatsApp como a API grava (só dígitos, com DDI): "5531999998888" vira
// "+55 (31) 99999-8888". Fora desse formato (outro país, número curto), devolve os dígitos crus
// em vez de inventar uma máscara errada.
export function whatsappMask(numero: string) {
  const digitos = numero.replace(/\D/g, '')
  // Formatado pelo tamanho, e não pelo phoneMask (que é de digitação e sempre separa 5 dígitos):
  // o número da instância chega com 10 dígitos nacionais em fixo e em linha sem o 9º dígito.
  const celular = digitos.match(/^55(\d{2})(\d{5})(\d{4})$/)
  if (celular) {
    return `+55 (${celular[1]}) ${celular[2]}-${celular[3]}`
  }
  const fixo = digitos.match(/^55(\d{2})(\d{4})(\d{4})$/)
  if (fixo) {
    return `+55 (${fixo[1]}) ${fixo[2]}-${fixo[3]}`
  }
  return digitos
}
